const buyButtons = document.querySelectorAll("[data-buy-button]");
if (buyButtons) {
  buyButtons.forEach((button) => {
    button.addEventListener("click", async function () {
      let variantID = parseInt(this.dataset.id);
      let formData = {
        items: [{ id: variantID, quantity: 1 }],
      };

      try {
        const response = await fetch(
          window.Shopify.routes.root + "cart/add.js",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          }
        );

        if (!response.ok) {
          const errorData = await response.json();
        } else {
          const data = await response.json();
          window.location = "/cart";
        }
      } catch (error) {
        console.error("ネットワークエラー:", error);
      }
    });
  });
}

const bisButtons = document.querySelectorAll("[data-bis-button]");
if (bisButtons) {
  bisButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const siTrigger = document.querySelector("#SI_trigger");
      siTrigger.dataset.variantId = button.dataset.variantId;
      siTrigger.click();
    });
  });
}

function initVariantsBuyStickyBars() {
  document.querySelectorAll("[data-product-buy-buttons-feature]").forEach((feature) => {
    const root = feature.querySelector(".product-buy-buttons--modal-root");
    const bar = feature.querySelector("[data-variants-sticky-bar]");
    if (!root || !bar) return;
    let isRootVisible = true;

    const updateStickyBarVisibility = () => {
      const isPageTop = window.scrollY <= 0;
      const shouldShow = !isRootVisible && !isPageTop;
      bar.classList.toggle("is-visible", shouldShow);
      bar.setAttribute("aria-hidden", shouldShow ? "false" : "true");
    };

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.target !== root) continue;
          isRootVisible = entry.isIntersecting;
          updateStickyBarVisibility();
        }
      },
      { root: null, threshold: 0, rootMargin: "0px" }
    );

    observer.observe(root);
    window.addEventListener("scroll", updateStickyBarVisibility, { passive: true });
    updateStickyBarVisibility();
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initVariantsBuyStickyBars);
} else {
  initVariantsBuyStickyBars();
}

galleryhanger();
function galleryhanger() {
  const thumbnailChangers = document.querySelectorAll("[data-gallery-changer]");
  if (!thumbnailChangers) return;
  thumbnailChangers.forEach((changer) => {
    const position = changer.dataset.mediaPosition;
    changer.addEventListener("click", () => {
      const target = document.querySelector(
        `.product-gallery__thumbnail[data-media-position="${position}"]`
      );
      if (!target) return;
      target.click();
    });
  });
}
